import Vue from 'vue';
import App from './App.vue'
import router from './router'
import VueIziToast from 'vue-izitoast'; // https://github.com/arthurvasconcelos/vue-izitoast
import 'izitoast/dist/css/iziToast.css';
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import VueCarousel from 'vue-carousel';
import Popover from 'vue-js-popover';
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtm from 'vue-gtm';
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

// validation
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { setInteractionMode } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';


/*import bugsnagClient from './bugsnag'
import bugsnagVue from '@bugsnag/plugin-vue'
bugsnagClient.use(bugsnagVue, Vue)*/

Vue.use(VueMoment)
Vue.use(VueCarousel)
Vue.use(Popover)
Vue.use(BootstrapVue)
//Vue.use(VueIziToast)
Vue.use(VueIziToast, {
    timeout:         3000,
    position:        "bottomRight",
    backgroundColor: "#4CAF50",
    color:           "white",
    titleColor:      "#fff",
    messageColor:    "#fff",
    iconColor:       "#fff",
    icon:            "fas fa-check"
});

// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
    plyr: {
        controls: ['play-large', 'play', 'progress', 'current-time']
    }
})

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCC4BYLxskWaOLGExG58eCPcN5sXnI7Vzw',
        libraries: 'geometry'
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

Vue.use(VueGtm, {
    id: 'GTM-K5QS7RN',
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});


/*if (process.env.NODE_ENV === "development") {
    Vue.prototype.$baseUrl = 'http://dev.oktodigital.com/adoptujkravicku/v2/'
    Vue.prototype.$assetsUrl = Vue.prototype.$baseUrl + 'assets/'
} else {
    Vue.prototype.$baseUrl = 'https://adoptujkravicku.sk/api/public/_'
    Vue.prototype.$assetsUrl = Vue.prototype.$baseUrl + 'assets/'
}*/

let messages = {
    "alpha": "{_field_} môže obsahovať len písmená",
    "alpha_dash": "{_field_} môže obsahovať len písmená, číslice, bodky a podčiarknutie",
    "alpha_num": "{_field_} môže obsahovať len písmená a číslice",
    "alpha_spaces": "{_field_} môže obsahovať len písmená, číslice a medzery",
    "between": "Položka {_field_} musí byť medzi {min} a {max}",
    "confirmed": "Hodnota položky {_field_} nie je rovnaká",
    "digits": "Položka {_field_} musí obsahovať {length} čísiel",
    "dimensions": "Položka {_field_} musí mať {width} x {height} pixelov",
    "email": "Položka {_field_} musí obsahovať platnú emailovú adresu",
    "excluded": "Položka {_field_} má nesprávnu hodnotu",
    "ext": "{_field_} nie je platný súbor",
    "image": "{_field_} nie je obrázok",
    "length": "{_field_} nie je platný",
    "oneOf": "Položka {_field_} má nesprávnu hodnotu",
    "max": "Položka {_field_} môže obsahovať najviac {length} znakov",
    "max_value": "Položka {_field_} musí byť maximálne {max}",
    "mimes": "Položka {_field_} obsahuje nesprávny typ súboru",
    "min": "Položka {_field_} musí obsahovať minimálne {length} znakov",
    "min_value": "Položka {_field_} musí byť minimálne {min}",
    "numeric": "Položka {_field_} môže obsahovať len číslice",
    "regex": "Formát položky {_field_} je nesprávny",
    "required": "Položka {_field_} je povinná",
    "required_if": "Položka {_field_} je povinná",
    "size": "Položka {_field_} musí byť menej ako {size}KB",
    "double": "Pole {_field_} musí byť platné desatinné miesto"
}

for (let [rule, validation] of Object.entries(rules)) {
    extend(rule, {
        ...validation,
        message: messages[rule]
    });
}

setInteractionMode('eager')

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

router.beforeEach((to, from, next) => {
    next()
})

var vm = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
});


